var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            design: "v3",
            "class-name": "bulk-user-modal",
            "show-footer": false,
            "show-title": false,
          },
          on: { cancel: _vm.onCancel },
        },
        [
          _c("div", { staticClass: "bulk-user-modal-content" }, [
            _c("div", { staticClass: "modal-section" }, [
              _c("div", { staticClass: "selection-wrapper" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("group_add"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("auto.userSelection")))]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("label", { staticClass: "field-label" }, [
                      _vm._v(_vm._s(_vm.$t("auto.users"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticClass: "user-select",
                        attrs: {
                          mode: "multiple",
                          size: "large",
                          placeholder: _vm.$t("auto.selectUser"),
                          "filter-option": _vm.filterOption,
                          "show-search": "",
                        },
                        model: {
                          value: _vm.selectedUsers,
                          callback: function ($$v) {
                            _vm.selectedUsers = $$v
                          },
                          expression: "selectedUsers",
                        },
                      },
                      _vm._l(_vm.availableUsers, function (user) {
                        return _c(
                          "a-select-option",
                          { key: user._id, attrs: { value: user._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(user.name || user.email) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-hint" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("lightbulb_outline"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("auto.canSelectMultipleUsers"))),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.selectedUsers.length > 0
                ? _c("div", { staticClass: "preview-section" }, [
                    _c("div", { staticClass: "preview-header" }, [
                      _c("div", { staticClass: "header-left" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("people"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("auto.selectedUsers"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "count-badge" }, [
                        _vm._v(_vm._s(_vm.selectedUsers.length)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "users-grid" },
                      _vm._l(_vm.selectedUsers, function (userId) {
                        return _c(
                          "div",
                          { key: userId, staticClass: "user-card" },
                          [
                            _c("div", { staticClass: "user-avatar" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("person"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-info" }, [
                              _c("div", { staticClass: "user-name" }, [
                                _vm._v(_vm._s(_vm.getUserName(userId))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-check" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("check_circle"),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("SupsisButton", { on: { click: _vm.onCancel } }, [
                  _vm._v(_vm._s(_vm.$t("auto.cancel"))),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { primary: "" }, on: { click: _vm.onConfirm } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("how_to_reg"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.assignUser")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }